import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { RefreshCw, Calendar } from "lucide-react";
const CashFundFlow = () => {
  const [cashFundFlowList, setCashFundFlowList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDept, setSelectedDept] = useState("-");
  const [departmentList, setDepartmentList] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const newDate = new Date();
  const today = newDate.toISOString().split("T")[0];
  const [toDate, setToDate] = useState(today);

  useEffect(() => {
    fetchCompanyInfo();
    fetchDepartments();
    fetchCashFundFlowList();
  }, []);

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setFromDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchDepartments = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;

      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };

  const fetchCashFundFlowList = async (drAcc) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMCashFundFlow/${company_code_from_local_storage}/CASHFLOW/${fromDate}/${toDate}/${selectedDept}`;

    try {
      setLoading(true);
      const response = await axios.get(url);
      const data = response.data;

      console.log("response data in stock ledger:", data);

      setCashFundFlowList(data || []);
    } catch (err) {
      console.error("Error while loading stock ledger:", err);
    } finally {
      setLoading(false);
    }
  };

  const getMonthKeys = (obj) =>
    Object.keys(obj).filter((key) => /^\d{4}-\d{2}$/.test(key));

  return (
    <div className=" overflow-auto h-[70vh]   scrollbar-auto-hide relative">
      <div className="flex items-center justify-left m-4 gap-4 ">
        <div className="">
          <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
            <Calendar className="w-4 h-4 mr-2 text-gray-600" />
            From Date
          </label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-full px-3 py-2.5 text-sm bg-gray-100  border border-gray-200  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
          />
        </div>

        <div className="">
          <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
            <Calendar className="w-4 h-4 mr-2 text-gray-600" />
            To Date
          </label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="w-full px-3 py-2.5 text-sm bg-gray-100   rounded-lg  border  border-gray-200
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
          />
        </div>

        <div>
          <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
            Department
          </label>
          <select
            value={selectedDept || ""}
            onChange={(e) => setSelectedDept(e.target.value)}
            className="w-full px-3 py-2.5  text-sm rounded border bg-gray-100 border-gray-200"
          >
            <option value="">Select Department</option>

            {departmentList.map((item, index) => (
              <option key={index} value={item.deptno}>
                {item.deptnodesc}
              </option>
            ))}
          </select>
        </div>

        <button
          onClick={fetchCashFundFlowList}
          disabled={loading}
          className={`flex items-center justify-center gap-2 
    font-medium px-2 py-1 rounded-lg text-sm
    transition-all duration-200 mt-6
    ${
      loading
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-indigo-500 text-white shadow hover:shadow-md hover:scale-[1.02] active:scale-100"
    }`}
        >
          <RefreshCw className="w-3 h-3" />
          {loading ? "Loading..." : "Apply"}
        </button>
      </div>

      <div className="">
        {loading && (
          <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/60 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-2">
              <div className="h-10 w-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
              <span className="text-xs text-gray-600 font-medium">
                Loading stock ledger...
              </span>
            </div>
          </div>
        )}
        <table className="w-full  text-xs border-collapse">
          <thead className="bg-gray-100 sticky top-0 z-10">
            <tr>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 z-10">
                ACCOUNT
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                AccDesc
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                CashBankType
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Financing
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Investing
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Opening Balance
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Operating
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                PDC Issued
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                PDC Received
              </th>

              {cashFundFlowList?.[0] &&
                getMonthKeys(cashFundFlowList[0]).map((month) => (
                  <th
                    key={month}
                    className="border px-2 py-1 text-right font-normal"
                  >
                    {month}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {cashFundFlowList?.length > 0 ? (
              cashFundFlowList.map((acc, index) => {
                const monthKeys = getMonthKeys(acc);
                return (
                  <tr key={acc?.INV || index} className="text-xs">
                    <td className="border bg-white px-2 py-1 text-left">
                      {acc?.ACCOUNT ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-left">
                      {acc?.AccDesc ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-left">
                      {acc?.CashBankType ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.Financing ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.Investing ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.OpeningBalance ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.Operating ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.PDCIssued ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.PDCReceived ?? "-"}
                    </td>
                    {monthKeys.map((month) => (
                      <td
                        key={month}
                        className="border  bg-white px-2 py-1 text-right"
                      >
                        {acc[month] ?? "-"}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={9} className="text-center py-4 text-gray-500">
                  {/* No outstanding data available */}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {!loading && cashFundFlowList.length === 0 && (
          <div className="flex items-center justify-center h-full text-gray-500 text-sm mt-60">
            No data found
          </div>
        )}
      </div>
    </div>
  );
};

export default CashFundFlow;
